import { produce } from 'immer';
import * as types from './sessionTypes';
import createReducer from '../utils/createReducer';

const initialState = {
    sessions: [],
    sessionsCount: 0,
    loading: true,
    targetAudienceReachByKey: {},
};

const actionHandlers = {
    [types.GET_SESSIONS.REQUEST]: produce((draft) => {
        draft.loading = true;
    }),
    [types.GET_SESSIONS.SUCCESS]: produce((draft, { total, sessions }) => {
        draft.sessions = sessions;
        draft.sessionsCount = total;
        draft.loading = false;
    }),
    [types.GET_SESSIONS.FAILURE]: produce((draft) => {
        draft.loading = false;
    }),
    [types.RESET_SESSIONS]: produce((draft) => {
        draft.sessions = [];
        draft.sessionsCount = 0;
        draft.loading = true;
    }),
    [types.SET_TARGET_AUDIENCE_REACH]: produce(
        (draft, { cacheKey, count }) => {
            if (!cacheKey || count === undefined || count === null) return;
            draft.targetAudienceReachByKey[cacheKey] = count;
        }
    ),
};

export default createReducer(initialState, actionHandlers);
